import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useThreeBackground, type CameraControls } from '@app/hooks/useThreeBackground'

export type BackgroundCameraControls = CameraControls

export const Background = forwardRef<BackgroundCameraControls, { isDimmed: boolean }>(({ isDimmed }, cameraControllerRef) => {
  const mountRef = useRef<HTMLDivElement>(null)

  const style = getComputedStyle(document.body)
  const ACCENT_COLOR = style.getPropertyValue('--accent-color').trim()
  const BACKGROUND_COLOR = style.getPropertyValue('--background-color').trim()
  const HEXAGON_COLOR = style.getPropertyValue('--hexagon-color').trim()

  const animateBackground = () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    return !prefersReducedMotion
  }

  const controls = useThreeBackground(
    mountRef,
    animateBackground(),
    {
      accentColor: ACCENT_COLOR,
      backgroundColor: BACKGROUND_COLOR,
      hexagonColor: HEXAGON_COLOR,
    },
    {
      onCameraMoveStart: () => {
        console.log('Camera move started')
      },
      onCameraMoveEnd: () => {
        console.log('Camera move ended')
      },
    }
  )

  useImperativeHandle(cameraControllerRef, () => controls, [controls])

  return (
    <>
      <div ref={mountRef} style={{ position: 'fixed', inset: 0, zIndex: -1 }} />
      <div className={`overlay${isDimmed ? ' overlay--dim' : ''}`} />
    </>
  )
})
